import React, { useContext } from "react";
// Chakra imports
import {
  Box,
  Flex,
  Button,
  FormControl,
  FormLabel,
  Heading,
  Input,
  Text,
  FormErrorMessage,
  VStack,
  Alert,
  AlertTitle,
  AlertIcon,
  AlertDescription,
} from "@chakra-ui/react";
// Assets
import signInImage from "assets/img/signInImage.png";
// Custom Components
import GradientBorder from "components/GradientBorder/GradientBorder";
import { useFormik } from "formik";
import * as yup from "yup";
import { login } from "service/user.service";
import { UserContext } from "context/user.context";
import { useHistory } from "react-router-dom";

function SignIn() {
  const [user, setUser] = useContext(UserContext);
  const history = useHistory();
  const titleColor = "white";
  const textColor = "gray.400";
  // formik
  const formik = useFormik({
    initialValues: {
      email: "",
      password: "",
    },
    validationSchema: yup.object().shape({
      email: yup.string().email().required("required"),
      password: yup.string().required("required"),
    }),
    onSubmit: async (values) => {
      setUser({ user: null, loading: true, error: null });
      try {
        const admin = await login(values);
        if (admin) {
          setUser({ user: admin.data, loading: false, error: null });
          history.push("/admin/dashboard");
        } else setUser({ user: admin, loading: false, error: "Invalid" });
      } catch (error) {
        setUser({ user: null, loading: false, error: "Invalid" });
      }
    },
  });
  return (
    <Flex position="relative">
      <Flex
        minH="100vh"
        h={{ base: "120vh", lg: "fit-content" }}
        w="100%"
        maxW="1044px"
        mx="auto"
        pt={{ sm: "100px", md: "0px" }}
        flexDirection="column"
        me={{ base: "auto", lg: "50px", xl: "auto" }}
      >
        <Flex
          alignItems="center"
          justifyContent="start"
          style={{ userSelect: "none" }}
          mx={{ base: "auto", lg: "unset" }}
          ms={{ base: "auto", lg: "auto" }}
          w={{ base: "100%", md: "50%", lg: "450px" }}
          px="50px"
        >
          <VStack
            spacing={"8"}
            w="100%"
            background="transparent"
            mt={{ base: "50px", md: "150px", lg: "160px", xl: "245px" }}
            mb={{ base: "60px", lg: "95px" }}
          >
            <Heading color={titleColor} fontSize="32px" mb="10px">
              Welcome!
            </Heading>
            <Text mb="36px" ms="4px" color={textColor} fontWeight="bold" fontSize="14px">
              Enter your email and password to sign in
            </Text>
            <FormControl isInvalid={formik.errors.email && formik.touched.email}>
              <FormLabel ms="4px" fontSize="sm" fontWeight="normal" color="white">
                Email
              </FormLabel>
              <GradientBorder
                mb="24px"
                w={{ base: "100%", lg: "fit-content" }}
                borderRadius="20px"
              >
                <Input
                  color="white"
                  bg="rgb(19,21,54)"
                  border="transparent"
                  borderRadius="20px"
                  fontSize="sm"
                  size="lg"
                  w={{ base: "100%", md: "346px" }}
                  maxW="100%"
                  h="46px"
                  placeholder="Your email address"
                  {...formik.getFieldProps("email")}
                />
              </GradientBorder>
              <FormErrorMessage>{formik.errors.email}</FormErrorMessage>
            </FormControl>
            <FormControl isInvalid={formik.errors.password && formik.touched.password}>
              <FormLabel ms="4px" fontSize="sm" fontWeight="normal" color="white">
                Password
              </FormLabel>
              <GradientBorder
                mb="24px"
                w={{ base: "100%", lg: "fit-content" }}
                borderRadius="20px"
              >
                <Input
                  color="white"
                  bg="rgb(19,21,54)"
                  border="transparent"
                  borderRadius="20px"
                  fontSize="sm"
                  size="lg"
                  w={{ base: "100%", md: "346px" }}
                  maxW="100%"
                  type="password"
                  placeholder="Your password"
                  {...formik.getFieldProps("password")}
                />
              </GradientBorder>
              <FormErrorMessage>{formik.errors.password}</FormErrorMessage>
            </FormControl>
            {/* <FormControl display="flex" alignItems="center">
              <DarkMode>
                <Switch id="remember-login" colorScheme="brand" me="10px" />
              </DarkMode>
              <FormLabel
                htmlFor="remember-login"
                mb="0"
                ms="1"
                fontWeight="normal"
                color="white"
              >
                Remember me
              </FormLabel>
            </FormControl> */}
            <Button
              variant="brand"
              fontSize="10px"
              type="submit"
              w="100%"
              maxW="350px"
              h="45"
              mb="20px"
              mt="20px"
              isLoading={formik.isSubmitting}
              onClick={formik.submitForm}
            >
              SIGN IN
            </Button>
            {user && user.error && (
              <Alert status="error">
                <AlertIcon />
                <AlertTitle>Invalid!</AlertTitle>
                <AlertDescription>Invalid userCredential.</AlertDescription>
              </Alert>
            )}
          </VStack>
        </Flex>
        <Box
          w={{ base: "335px", md: "450px" }}
          mx={{ base: "auto", lg: "unset" }}
          ms={{ base: "auto", lg: "auto" }}
          mb="80px"
        ></Box>
        <Box
          display={{ base: "none", lg: "block" }}
          overflowX="hidden"
          h="100%"
          maxW={{ md: "50vw", lg: "50vw" }}
          minH="100vh"
          w="960px"
          position="absolute"
          left="0px"
        >
          <Box
            bgImage={signInImage}
            w="100%"
            h="100%"
            bgSize="cover"
            bgPosition="50%"
            display="flex"
            flexDirection="column"
            justifyContent="center"
            alignItems="center"
            position="absolute"
          >
            <Text
              textAlign="center"
              color="transparent"
              letterSpacing="8px"
              fontSize="36px"
              fontWeight="bold"
              bgClip="text !important"
              bg="linear-gradient(94.56deg, #FFFFFF 79.99%, #21242F 102.65%)"
            >
              PCARI GIGS
            </Text>
          </Box>
        </Box>
      </Flex>
    </Flex>
  );
}

export default SignIn;
